import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { BitmapText } from "appworks/graphics/pixi/bitmap-text";
import { AbstractTextControl } from "appworks/ui/controls/standard/text/abstract-text-control";
import { slotModel } from "slotworks/model/slot-model";

export class AgsTotalCreditsTextControl extends AbstractTextControl {
    protected onModelUpdateCallback: Function;

    constructor(text: FlexiText | BitmapText) {
        super(text);

        this.onModelUpdateCallback = () => this.onModelUpdate();
        slotModel.onUpdate.add(this.onModelUpdateCallback);

        this.onModelUpdate();
    }

    public destroy(): void {
        super.destroy();
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

    public onModelUpdate(): void {
        const { creditsPerLine, winLines} = slotModel.read().bet;
        const numLines = winLines?.currentValue ?? 1;
        this.text.setText((creditsPerLine.currentValue * numLines).toString());
    }
}
